import React from 'react';

export const IA_JOB_PHASES = [
  { key: 'recebidos', label: 'Recebidos' },
  { key: 'analisando', label: 'Analisando' },
  { key: 'processando', label: 'Processando' },
  { key: 'finalizando', label: 'Finalizando' },
  { key: 'aguarde', label: 'Aguarde' },
  { key: 'ok', label: 'Ok' },
];

function phaseBarClass(i, idx, phase) {
  const filled = i <= idx;
  const active = i === idx && phase !== 'ok';
  return [
    'h-1 flex-1 rounded-full transition-colors',
    filled ? 'bg-iron-accent' : 'bg-iron-border',
    active ? 'animate-pulse' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

function PhaseBars({ phase, className = '', compact = false }) {
  const idx = Math.max(0, IA_JOB_PHASES.findIndex((p) => p.key === phase));
  const current = IA_JOB_PHASES[idx] || IA_JOB_PHASES[0];

  return (
    <div
      className={`flex gap-1 ${compact ? 'w-24' : 'w-full'} ${className}`}
      role="status"
      aria-live="polite"
      aria-busy={phase !== 'ok'}
      aria-label={`Fase: ${current.label}`}
    >
      {IA_JOB_PHASES.map((p, i) => (
        <span key={p.key} className={phaseBarClass(i, idx, phase)} aria-hidden />
      ))}
    </div>
  );
}

/**
 * Stepper compacto das fases de um job IA.
 */
export default function IaPhasedLoading({
  phase = 'recebidos',
  className = '',
  compact = false,
  barsOnly = false,
  hint = '',
}) {
  const idx = Math.max(0, IA_JOB_PHASES.findIndex((p) => p.key === phase));
  const current = IA_JOB_PHASES[idx] || IA_JOB_PHASES[0];

  if (barsOnly) {
    if (compact) {
      return <PhaseBars phase={phase} className={className} compact />;
    }

    return (
      <div className={`space-y-2 ${className}`}>
        <PhaseBars phase={phase} />
        {hint ? <p className="font-mono text-[10px] text-iron-muted/80">{hint}</p> : null}
      </div>
    );
  }

  if (compact) {
    return (
      <div
        className={`font-mono text-[11px] text-iron-muted ${className}`}
        role="status"
        aria-live="polite"
        aria-busy={phase !== 'ok'}
      >
        <span className="text-iron-accent">{current.label}</span>
        <span className="text-iron-muted/70">
          {' '}
          · {idx + 1}/{IA_JOB_PHASES.length}
        </span>
        {hint ? (
          <span className="mt-0.5 block text-[10px] normal-case tracking-normal text-iron-muted/80">
            {hint}
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <div className={`space-y-2 ${className}`} role="status" aria-live="polite" aria-busy={phase !== 'ok'}>
      <div className="flex gap-1">
        {IA_JOB_PHASES.map((p, i) => (
          <span key={p.key} className={phaseBarClass(i, idx, phase)} aria-hidden />
        ))}
      </div>
      {hint ? <p className="font-mono text-[10px] text-iron-muted/80">{hint}</p> : null}
      <ul className="space-y-1">
        {IA_JOB_PHASES.map((p, i) => (
          <li
            key={p.key}
            className={`font-mono text-[10px] uppercase tracking-wide ${
              i < idx
                ? 'text-iron-muted/50 line-through'
                : i === idx
                  ? 'text-iron-accent'
                  : 'text-iron-muted/40'
            }`}
          >
            {p.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
